import React, { useLayoutEffect, useContext, } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation, } from "react-router-dom"
import parse from 'html-react-parser';

import constant from '../../Constant';
import Breadcrumb, {BreadcrumbItem} from '../../components/Breadcrumb';
import { BlankLink } from '../../components/CustomLink';
import ApiService from '../../services/ApiService';
import { responseParser, convertFisicalYearGen } from '../../functions/Utitilty';
import { LocalCasheContext } from '../../context/LocalCacheContext';

import loading from '../../assets/img/search/loading.svg';

import SearchForm, { defaultValues, SearchFormValues, setSearchValues, } from './common/SearchForm';
import FigureImage from './common/FigureImage';
import SearchAlert from './common/AlertMessage';

import {ToManyError, ValidateError} from '../../services/ServiceError';
 

const SearchResult = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const localCasheContext = useContext(LocalCasheContext);

    const service = new ApiService();

    // 検索条件
    const searchCondition:SearchFormValues = (location.state)?location.state.formData:defaultValues;
    // 検索条件が指定されていない場合（直アクセス）は検索TOPへ遷移
    if (searchCondition.searchWord == defaultValues.searchWord) {
        navigate('/search/YDSG010')
    }
    
    // 現在のURLを前画面判定用キャッシュに保存
    localCasheContext.push('url', window.location.href);

    // 
    const [errorElement, setErrorElement] = React.useState<JSX.Element[]>([])
    const [maxView, setMaxView] = React.useState<number>(0);
    const [start, setStart] = React.useState<number>(0);
    const [end, setEnd] = React.useState<number>(0);
    const [searchResult, setSearchResult] = React.useState<any[]>([]);
    const [isLoading, setLoading] = React.useState(false);

    // 全体エラークリア
    const handleClearError = () => {
        setErrorElement([]);
    }

    // 表示順変更イベントハンドラ
    const handleChangeSort = (sort: string) => {

        const formData = searchCondition;
        formData.searchSort = sort;
        
        navigate('/search/YDSG020SEARCH', {state:{'formData': formData}});
    };
    // ページ切替イベントハンドラ
    const handleChangePage = (page: number) => {

        const formData = searchCondition;
        formData.page = page;

        // スクロール
        //scrollToResult();
        scrollToResult(
            'instant',
            () => {navigate('/search/YDSG020SEARCH', {state:{'formData': formData}});}
        );
    }
    // 検索ボタン押下イベントハンドラ
    const handleSearch = (formData:any) => {

        formData.page = defaultValues.page; // ページを先頭に戻す
        formData.searchSort = defaultValues.searchSort; // ソートをnewに戻す

        // 検索値をセッションストレージに保存
        setSearchValues(formData);
        
        // スクロール
        scrollToResult(
            'smooth',
            () => {navigate('/search/YDSG020SEARCH', {state:{'formData': formData}});}
        );
    }

    // 「検索結果」を画面上部に持ってくるcallback
    const scroolTargetRef = React.createRef<HTMLDivElement>();
    const scrollToResult = React.useCallback((behavior:string, callback:Function) => {
        let id:any = undefined;
         const onScroll = () => {
            clearTimeout(id);
            id = setTimeout(() => {
                window.removeEventListener('scroll', onScroll);
                callback()
            }, 100);
        }
        
        window.addEventListener('scroll', onScroll);

        (scroolTargetRef!.current!.scrollIntoView as any)({
            behavior: behavior,
            block: 'start',
        });
      }, [ scroolTargetRef ])
    
    /**
     * 検索処理
     */
    useLayoutEffect(() => {
        // キャッシュ復元
        const session = sessionStorage.getItem(location.key);
        if (session) {
            const sessionData:any = JSON.parse(session);
            setMaxView(sessionData.maxView);
            setStart(sessionData.start);
            setEnd(sessionData.end);
            setSearchResult(sessionData.searchResult);
            return;
        }

        setLoading(true);  // ロード中フラグON
        document.body.style.cursor = "progress";

         // エラーメッセージクリア
        handleClearError();
        // 検索結果をクリア
        setMaxView(0);
        setStart(0);
        setEnd(0);
        setSearchResult([]);

        const json = {
            searchWord: searchCondition.searchWord,
            //searchOrAnd: 'or',
            searchSort: searchCondition.searchSort,
            selectFiscalYearLeft: Number(searchCondition.selectFiscalYearLeft),
            selectFiscalYearRight: Number(searchCondition.selectFiscalYearRight),
            page: searchCondition.page,
            chkInfoYosan: searchCondition.chkInfoYosan,
            chkInfoKessan: searchCondition.chkInfoKessan,
            typeOfBudgetSearchList: searchCondition.typeOfBudgetSearchList,
            typeOfBudgetYosanItemList: searchCondition.typeOfBudgetYosanItemList,
            runningTitleYosanItemList1: searchCondition.runningTitleYosanItemList1,
            runningTitleYosanItemList2: searchCondition.runningTitleYosanItemList2,
            typeOfBudgetKessanItemList: searchCondition.typeOfBudgetKessanItemList,
            runningTitleKessanItemList1: searchCondition.runningTitleKessanItemList1,
            runningTitleKessanItemList2: searchCondition.runningTitleKessanItemList2,
        };

        // API実行
        service.search(json)
            .then((json:any) => {
                if (json.message) {
                    setErrorElement([
                        <SearchAlert>
                            <p className="c-box__lead">{json.message}</p>
                        </SearchAlert>
                    ]);
                    return;
                }
                
                if (json.hits.total.value == 0) {
                    setErrorElement([
                        <SearchAlert>
                            <p className="c-box__lead">検索キーワードに該当する箇所が見つかりませんでした</p>
                            <p className="c-box__text">検索条件を変更して再検索してください。</p>
                            <p className="c-box__text">なお、特殊な文字・記号は検索できない場合があります。</p>
                            <p className="c-box__text">詳細は<BlankLink href='/manual/manual.pdf'>検索操作マニュアル</BlankLink>をご参照ください。</p>
                        </SearchAlert>
                    ]);
                    return;
                }
          
                let maxView = 0;
                if (json.hits.total.value > 1000) {
                  setErrorElement([
                      <SearchAlert>
                          <p className="c-box__lead">検索結果が1000件を超えています</p>
                          <p className="c-box__text">条件を絞り込んで再検索してください。</p>
                      </SearchAlert>
                  ]);
                  
                  maxView = 1000;
                } else {
                  maxView = json.hits.total.value;
                }
        
                // 表示件数算出
                let start = 1 + (searchCondition.page-1)*constant.search.PAGE_VIEW_LIMIT;
                let end = (searchCondition.page)*constant.search.PAGE_VIEW_LIMIT;
                if (end > maxView) {
                  end = maxView;
                }
        
                // レスポンスを表示用配列にパース
                const response = responseParser(json);
                // 結果セット
                setMaxView(maxView);
                setStart(start);
                setEnd(end);
                setSearchResult(response);
                
                // キャッシュに保存
                try{
                    sessionStorage.setItem(location.key, JSON.stringify({
                        maxView: maxView,
                        start: start,
                        end: end,
                        searchResult: response
                    }));
                }catch(e) {
                }
            })
            .catch((err:Error) => {
                if (process.env.NODE_ENV === 'development') {
                  setErrorElement([
                    <SearchAlert>
                        <p className="c-box__lead">{err.message}</p>
                        {err.stack?.split("\\n").map((value:string) => (
                        <p className="c-box__text">{value}</p>
                        ))}
                    </SearchAlert>
                ])
                } else if (err instanceof ValidateError) { // バリデーションエラー
                    setErrorElement([
                      <SearchAlert>
                          <p className="c-box__lead">{err.message}</p>
                      </SearchAlert>
                  ])
                } else if (err instanceof ToManyError) {  // lambdaの6MB制限エラー
                    setErrorElement([
                        <SearchAlert>
                            <p className="c-box__lead">検索結果の表示制限により、結果を表示できません</p>
                            <p className="c-box__text">条件を絞り込んで再検索してください。</p>
                        </SearchAlert>
                    ])
                } else {
                    setErrorElement([
                        <SearchAlert>
                            <p className="c-box__lead">システムエラーが発生しました</p>
                            <p className="c-box__text">お手数ですが、しばらく時間を置いてから、再度操作していただけますようお願いします。</p>
                        </SearchAlert>
                    ])
                }
            })
            .finally(() => {
                setLoading(false);  // ロード中フラグOFF
                document.body.style.cursor = "auto";
            })
    }, [searchCondition]);

    // パンくずリストリンク
    const breadcrumbItems:BreadcrumbItem[] = [
        {'label': 'ホーム', 'path': '/'},
        {'label': '語句検索', 'path':'/search/YDSG010'},
        {'label': '検索結果', 'path': '/search/YDSG020SEARCH'},
    ]

    //
    return (
        <>
        <Helmet>
            <title>語句検索結果 | 予算書・決算書データベース</title>
        </Helmet>
        <main id="main" className="l-contents-main">
        <div className="l-contents l-contents--head">
            <div className="l-contents__inner">

            <Breadcrumb itemLists = {breadcrumbItems} />

            <div className="c-blk-head">
                <h1 className="c-heading-lv1">語句検索結果</h1>
            </div>

            </div>
        </div>
        <div className="l-contents l-contents--body">
            <div className="l-contents__inner">

            <SearchForm accordionOpen={false} values={searchCondition} onSearch={handleSearch} />

            <div className="c-blk-head" ref={scroolTargetRef}>
                <h2 className="c-heading-lv2" id="result">検索結果</h2>
            </div>
            {isLoading &&
            <div className="c-blk-txt u-text-center">
                <img src={loading} width="128" />
            </div>
            }
            {!isLoading &&
            <div className="c-blk-txt c-blk-txt--lg c-flex c-flex--between">
                {maxView == 0 &&
                <p className="c-flex__grow">0件</p>
                }
                {maxView > 0 &&
                <p className="c-flex__grow">{maxView}件中 {start}～{end}件表示しています。</p>
                }
                {searchCondition.searchSort === "new" &&
                <ul className="c-flex__fix c-sort">
                <li className="c-sort__text">新しい年度順</li>
                <li><button type="button" className="c-button c-button--xsm c-button--tertiary"  onClick={()=>{ handleChangeSort("old"); }}>
                    <span className="c-button__txt">古い年度順</span>
                </button></li>
                </ul>
                }
                {searchCondition.searchSort === "old" &&
                <ul className="c-flex__fix c-sort">
                <li><button type="button" className="c-button c-button--xsm c-button--tertiary" onClick={()=>{ handleChangeSort("new"); }}>
                    <span className="c-button__txt">新しい年度順</span>
                </button></li>
                <li className="c-sort__text">古い年度順</li>
                </ul>
                }
            </div>
            }
            {errorElement &&
            <div className="c-blk-txt">
                {errorElement}
            </div>
            }
            {searchResult.map((element:any) => {

                // 年度
                const order = element.display_order.substr(0, 2);
                const order_text = (constant.document.DISPLAY_ORDER_ITEMS[order])?constant.document.DISPLAY_ORDER_ITEMS[order]:"＜なし＞";

                return (
                    <>
                    <div className="c-blk-head">
                        <h3 className="c-heading-lv4">（{convertFisicalYearGen(element.fisical_year_gen)}） {order_text}</h3>
                    </div>
                    {element.source.map((source:any) => (
                        <div className="c-result-item">
                            <div className="c-result-item__num">{start + source.lineNo}</div>
                            <div className="c-result-item__group">
                            <h4 className="c-result-item__head">{source.line1}<br/>
                                <span className="c-result-item__head--lv2">{source.line2}</span><br/>
                                <span className="c-result-item__head--lv3">{source.line3}</span></h4>
                            <dl className="c-result-item__detail-list">
                            {source.innerHits.map((hit:any, idx:number) => {

                                // 上限以上は表示しない
                                if (idx > (constant.search.INNER_VIEW_LIMIT - 1)) {
                                    return;
                                }
                                
                                // ハイライトテキスト
                                let highligth = hit._source.data_highlight;
                                if (Array.isArray(highligth)) {
                                    highligth = highligth.join('・・・<br/>');
                                }
                                // PDFリンク
                                const pdfLink = process.env.REACT_APP_PDF_URL+"/"+hit._source.fisical_year+"/pdf/"+hit._source.pdf_file_name;
                                // PDFプレビューURL
                                const previewUrl = process.env.REACT_APP_PDF_URL+"/"+hit._source.fisical_year+"/thumbnail/"+hit._source.pdf_file_name.replace('pdf', 'png');

                                return (
                                <div className="c-result-item__detail">
                                <dt className="c-result-item__detail__label"><a href={pdfLink} target="_blank" className="c-button c-button--xsm c-button--secondary">{hit._source.pdf_page}</a><FigureImage url={previewUrl} /></dt>
                                <dd className="c-result-item__detail__text">{parse(highligth)}</dd>
                                </div>
                                )
                            })}
                            </dl>
                            {source.innerHits.length > constant.search.INNER_VIEW_LIMIT &&
                            <SearchAlert>
                                <p className="c-box__lead">検索キーワードの出現箇所が50件を超えています</p>
                                <p className="c-box__text">条件を絞り込んで再検索してください。</p>
                            </SearchAlert>
                            }
                            </div>
                        </div>
                    ))}
                    </>
                )
            })
            }
        </div>

        <div className="c-blk-cont">
        {!isLoading &&
            <nav aria-label="ページネーション">
            <ul className="c-pagination">
                <li className="c-pagination__item">
                <a href="#result" aria-label="ページ1" tabIndex={(searchCondition.page===1)?-1:undefined} aria-current={(searchCondition.page===1)?"page":undefined} onClick={(e) => { e.preventDefault();handleChangePage(1); }}>1</a>
                </li>
                {(maxView >= (1 * constant.search.PAGE_VIEW_LIMIT) + 1) &&
                <li className="c-pagination__item">
                <a href="#result" aria-label="ページ2" tabIndex={(searchCondition.page===2)?-1:undefined} aria-current={(searchCondition.page===2)?"page":undefined} onClick={(e) => { e.preventDefault();handleChangePage(2); }}>2</a>
                </li>
                }
                {(maxView >= (2 * constant.search.PAGE_VIEW_LIMIT) + 1) &&
                <li className="c-pagination__item">
                <a href="#result" aria-label="ページ3" tabIndex={(searchCondition.page===3)?-1:undefined} aria-current={(searchCondition.page===3)?"page":undefined} onClick={(e) => { e.preventDefault();handleChangePage(3); }}>3</a>
                </li>
                }
                {(maxView >= (3 * constant.search.PAGE_VIEW_LIMIT) + 1) &&
                <li className="c-pagination__item">
                <a href="#result" aria-label="ページ4" tabIndex={(searchCondition.page===4)?-1:undefined} aria-current={(searchCondition.page===4)?"page":undefined} onClick={(e) => { e.preventDefault();handleChangePage(4); }}>4</a>
                </li>
                }
                {(maxView >= (4 * constant.search.PAGE_VIEW_LIMIT) + 1) &&
                <li className="c-pagination__item">
                <a href="#result" aria-label="ページ5" tabIndex={(searchCondition.page===5)?-1:undefined} aria-current={(searchCondition.page===5)?"page":undefined} onClick={(e) => { e.preventDefault();handleChangePage(5); }}>5</a>
                </li>
                }
            </ul>
            </nav>
        }
        </div>
        </div>
        </main>
        </>
    )
};

export default SearchResult;